module.exports = __webpack_public_path__ + "static/media/bg_welcome.f1665a3c.png";